/**
 * AP-11 — Umwandlung gelesener Trace-Frames in das gepackte Batch-Format aus
 * CONTRACTS.md §3.2, damit `playbackLoad` sie als Transferable an den Worker
 * geben kann. Zugriff ausschließlich über `writeFrameRecord` (Vertragspflicht).
 */

import type { CanFrame } from '../can/ICanAdapter';
import { FRAME_FLAG, FRAME_RECORD_SIZE, writeFrameRecord } from '../worker/protocol';

export function packFrames(frames: readonly CanFrame[]): ArrayBuffer {
  const buffer = new ArrayBuffer(frames.length * FRAME_RECORD_SIZE);
  const view = new DataView(buffer);
  for (let i = 0; i < frames.length; i += 1) {
    const frame = frames[i];
    if (frame === undefined) continue;
    let flags = FRAME_FLAG.replay;
    if (frame.extended) flags |= FRAME_FLAG.extended;
    if (frame.remote) flags |= FRAME_FLAG.remote;
    // `seq` vergibt erst der Worker beim Einspeisen; hier nur der Index.
    writeFrameRecord(view, i, { ...frame, seq: i, flags });
  }
  return buffer;
}
